import { IAccountPageLang } from '../../../types/lang'

export const accountPageLang: IAccountPageLang = {
	account_page: {
		notification_deleted_accounts_count: '{{cnt}} accounts_ua',
		notification_deleted_accounts_title: 'are deleted_ua',
		btn_add_new: 'Add New_ua',
		btn_delete_multiple_items: 'Delete {{cnt}} items_ua'
	}
}